import { base64ToBase64Url, base64UrlToBase64 } from './util/base64url';
import { getEnv } from './env';
const productShorthands = {
  confluence: 'c',
  jira: 'j',
  stride: 's',
  bitbucket: 'b',
  trello: 't'
};
export function encode(originData) {
  const json = JSON.stringify(toJSONObject(originData));
  const base64 = getEnv().btoa(json);
  return base64ToBase64Url(base64);
}
export function decode(encodedOriginString) {
  const base64 = base64UrlToBase64(encodedOriginString);
  const json = getEnv().atob(base64);
  return fromJSONObject(JSON.parse(json));
}
export function toJSONObject({
  id,
  product
}) {
  return {
    i: id,
    p: product && product in productShorthands ? productShorthands[product] : product
  };
}
export function fromJSONObject(originJSONObject) {
  const originData = {};

  if (originJSONObject.i) {
    originData.id = originJSONObject.i;
  }

  if (originJSONObject.p) {
    originData.product = expandProductShorthand(originJSONObject.p);
  }

  return originData;
}

function expandProductShorthand(maybeShorthand) {
  const products = Object.keys(productShorthands);

  for (let i = 0; i < products.length; i++) {
    const product = products[i];
    const shorthand = productShorthands[product];

    if (maybeShorthand === shorthand) {
      return product;
    }
  }

  return maybeShorthand;
}